function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const CloudFunctionsIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.76 2.43l2.87 2.88-4.24 4.25v13.11l4.24 4-2.87 2.9L0 23.95V8.18zM26.24 2.43l-2.87 2.88 4.24 4.25v13.11l-4.24 4 2.87 2.9L32 23.95V8.18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10.04",
    cy: "16",
    r: "2.12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "21.96",
    cy: "16",
    r: "2.12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2.12"
  }));
};
export default CloudFunctionsIcon;